// extracted by mini-css-extract-plugin
export default {"fieldset__legend":"_2nMa902QQrBA5PrgEqm-LA","fieldset":"_2oQ2a3C6pGbl_ahGIny6T3","fieldset--horizontal":"_1ziOh47wulxDb3DcgbnWzQ"};